<ng-container *ngIf="url">
  <a [href]="url" target="_blank">
    <span class="link-value">{{ label || url | translate }}</span>
    <span class="link-tag" translate
      >app.open
      <fa-icon icon="external-link" [fixedWidth]="true"></fa-icon>
    </span>
  </a>
</ng-container>
